{
  "de": {
    "table": {
      "cells": {
        "storageLocation": {
          "personal": "Meine Ablage"
        }
      },
      "columns": {
        "access": "Zugänge",
        "author": "Autor",
        "created": "Erstellt am",
        "date": "Datum",
        "deletion": "Löschung am",
        "invitedBy": "Einladung von",
        "joinedAt": "Beigetreten am",
        "name": "Name",
        "projects": "Projekte",
        "school": "Schule",
        "select": "Auswahl",
        "selectAll": "Alle auswählen",
        "status": "Status",
        "progress": "Fortschritt",
        "feedback": "Feedback",
        "updatedAt": "Geändert am",
        "updated_at": "Geändert am",
        "folder": "Ordner",
        "storageLocation": "Ablageort",
        "source": "Quelle",
        "responses": "Abgaben",
        "responsesCount": "Anzahl Abgaben",
        "drafts": "Entwürfe",
        "preCorrections": "Vorkorrekturen",
        "title": "Titel",
        "archivedAt": "Archiviert am",
        "description": "Beschreibung",
        "projectsCount": "Projekte"
      },
      "author": {
        "currentUser": "Ich"
      },
      "emptyState": {
        "noContent": "Es konnten keine Inhalte gefunden werden",
        "noSearchResults": "Für diese Suche gibt es keine Treffer."
      }
    }
  }
}
